module.exports = __webpack_public_path__ + "assets/img/bfe76aff8127abc118a77fbc7c63fc4e.webp";